import React, { useState } from 'react';
import { ReactComponent as ChatBubbleIcon } from 'assets/chat-bubble.svg';
import PepWiseAIChatPopup from './PepWiseAIChatPopup';
import './PepWiseAIChatPopup.scss';

const AskMeButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(() => {
    return sessionStorage.getItem('pepwise_chat_isOpen') === 'true';
  });

  const toggleOpen = (open: boolean) => {
    setIsOpen(open);
    sessionStorage.setItem('pepwise_chat_isOpen', String(open));
  };

  return (
    <>
      {!isOpen && (
        <button
          id="ask-me-button"
          className="ask-me-fab"
          onClick={() => toggleOpen(true)}
          aria-label="Open PepWise AI Chat"
        >
          <span className="ask-me-label">Ask Me</span>
          <span className="ask-me-icon" aria-hidden="true">
            <ChatBubbleIcon width={36} height={31} />
          </span>
        </button>
      )}

      {isOpen && (
        <PepWiseAIChatPopup
          onClose={() => toggleOpen(false)}
          suggestedPrompts={[]}
          initialMessages={[
            {
              id: 1,
              role: 'assistant',
              content: 'Hello, I am the Pipeline Observability Assistant. Currently, my scope is limited to the Mosaic platform and ADF Orchestrator. How can I assist you today?',
              time: new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
            },
          ]}
        />
      )}
    </>
  );
};

export default AskMeButton;
